import axios from 'axios';
import React, { useState } from 'react';

export default function DeleteAccount() {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const [isVerified, setIsVerified] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleVerify = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
          const { data } = await axios.post('/api/auth', formData);
          
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
          localStorage.setItem('role', data.user.role);
          
          setIsVerified(true);
        } catch (err: any) {
          setError(err.response?.data?.error || 'Invalid email or password');
        }
    };

    const handleDeleteAccount = () => {
        // TODO: Add actual delete account logic here
        if (window.confirm('Are you sure you want to delete your account? This action cannot be undone.')) {
            console.log('Account deleted');
        }
    };

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
            <h1 className="text-2xl font-bold text-red-600 mb-6">Delete Account</h1>
            
            {!isVerified ? (
                <form onSubmit={handleVerify} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-1">Username</label>
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleInputChange}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-1">Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
                    >
                        Verify Identity
                    </button>
                </form>
            ) : (
                <div className="space-y-4">
                    <p className="text-gray-600">
                        Your identity has been verified. Are you sure you want to delete your account?
                        This action cannot be undone.
                    </p>
                    <button
                        onClick={handleDeleteAccount}
                        className="w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
                    >
                        Delete My Account
                    </button>
                </div>
            )}
        </div>
    );
}